














































import Vue from 'vue';
import { getSortType, tableSortTypes } from '@/helpers/tableHelpers';
import { ISortTypes } from '../types';

export default Vue.extend({
  name: 'TableSortIcons',

  props: {
    sortColumn: {
      type: String,
      required: true,
    },
  },

  computed: {
    sortType(): string {
      return getSortType(this.sortColumn);
    },
    sortTypes(): ISortTypes {
      return tableSortTypes();
    },
  },
});
